import React, { ReactNode } from 'react';
import './styles.scss';

interface IStyledButton {
  onClick?: (e) => void;
  className?: string;
  disabled?: boolean;
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const StyledButton = ({
  onClick,
  className,
  disabled,
  children,
  type,
}: IStyledButton) => {
  return (
    <button
      onClick={onClick}
      className={`styled-button ${className || ''}`}
      disabled={disabled}
      type={type || 'button'}
    >
      {children}
    </button>
  );
};

export default StyledButton;
